import type React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, message, Spin, Text } from 'ui';

import { linkWithings, unlinkWithings } from './services/api';
import WithingsLoginButton from './WithingsLoginButton';

type P = {
  user: any;
  search?: string;
  onRequestReloadUser: () => Promise<void>;
};

const WithingsSync: React.FC<P> = ({ user, search, onRequestReloadUser }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const isLinkedWithings = () => {
    return user?.withings?.user_id;
  };

  const onUnlinkWithings = async () => {
    setLoading(true);

    const response = await unlinkWithings(user.withings.user_id);
    if (response.ok) {
      await onRequestReloadUser();
    } else {
      message.error(t('Something went wrong'));
    }

    setLoading(false);
  };

  const renderUnlinkWithings = () => {
    return (
      <Button onClick={onUnlinkWithings} className="withings-button" size="large">
        {t('Unlink my Withings Account')}
      </Button>
    );
  };

  const renderLinkWithings = () => {
    return <WithingsLoginButton />;
  };

  const linkWithingsAccount = useCallback(async () => {
    if (search) {
      const query = new URLSearchParams(search);
      const code = query.get('code');

      if (code) {
        setLoading(true);

        const response = await linkWithings(code);
        if (response.ok) {
          await onRequestReloadUser();
        } else {
          message.error(t('Something went wrong'));
        }

        setLoading(false);
      }
    }
  }, [search, onRequestReloadUser, t]);

  useEffect(() => {
    linkWithingsAccount();
  }, [linkWithingsAccount]);

  return (
    <>
      <Text className="withings-label">{t('Withings Sync')}</Text>
      {loading ? <Spin size="large" /> : <>{isLinkedWithings() ? renderUnlinkWithings() : renderLinkWithings()}</>}
    </>
  );
};

export default WithingsSync;
